// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

import VueResource from 'vue-resource'
import MomentJs from 'vue-moment'
import Vuex from 'vuex'
import AcSdk from './adminconsole-sdk.js'
import Auth from './auth-sdk.js'
import axios from 'axios'

Vue.use(Auth, {
  api: 'https://api.edexis.com/wapi/',
  level: 1
})

Vue.use(AcSdk, {
  api: 'https://api.edexis.com/wapi/',
  loginRouteName: 'login',
  ignoreRoutes: [
    'login',
    'register',
    'authreset'
  ]
})

import store from './components/store'

Vue.use(VueResource)
Vue.use(MomentJs)

Vue.use(Vuex)

/* Import Required Template Styles */
import 'style-loader!bootstrap/dist/css/bootstrap.min.css'
import 'style-loader!@/template/gentelella/css/font-awesome.min.css'
// import 'style-loader!@/template/gentelella/css/green.css'
import 'style-loader!@/template/gentelella/css/bootstrap-progressbar-3.3.4.min.css'
import 'style-loader!@/template/gentelella/css/jquery-jvectormap-2.0.3.css'
import 'style-loader!@/template/gentelella/css/custom.min.css'
/* END Import Required Template Styles */

axios.interceptors.response.use(res => {
  if (res.data.Function.success === false) {
    this.$router.push({ name: 'login' })
    return
  }

  return res
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

Vue.http.options.credentials = true
Vue.http.options.xhr = {withCredentials: true}
Vue.http.options.emulateJSON = true



// WEBPACK FOOTER //
// ./src/main.js